import HttpService from './HttpService';
export default class ProductService {
  constructor() {
    this._httpService = new HttpService();
  }

  async FindAll() {
    return await this._httpService.get('/api/salesforce/product2');
  }

  async FindPriceAll() {
    return await this._httpService.get('/api/salesforce/product_price');
  }

  async FindRegions() {
    return await this._httpService.get('api/salesforce/product2/describe');
  }

  getCalcQuotePJ(seguradoras, tabelaBeneficiarios) {

    // percorrer seguradoras
    seguradoras.forEach(seg => {
      seg.menorPreco = 0;
      // percorrer beneficiarios
      tabelaBeneficiarios.forEach(ben => {
        // definir preços para cada tabela beneficiarios
        if (ben.t > 0 || ben.d > 0) {
          // verifica seguradoras tem preços.
          if (seg.precos && seg.precos.length > 0) {
            // faixa etaria
            if (seg.precos.some(s => ben.min >= s.idadeDe && ben.min <= s.idadeAte)) {
              // encotrou preço para faixa etaria
              var preco = seg.precos.filter(s => ben.min >= s.idadeDe)[0];

              // somatorio
              if (ben.t && parseInt(ben.t) > 0)
                seg.menorPreco += (parseFloat(preco.valorTitular) * parseInt(ben.t));

              if (ben.d && parseInt(ben.d) > 0)
                seg.menorPreco += (parseFloat(preco.valorDependente) * parseInt(ben.d));

              // if (ben.d > 0)
              //   seg.preco += (preco.valorTitular * ben.d);
            }
          }
        }
      });
    });

    //     // sort
    //     seg.planos = seg.planos.sort(function (a, b) {
    //       return a.preco <= b.preco ? -1 : a.preco > b.preco ? 1 : 0;
    //     });

    //     // set menor preço
    //     seg.menorPreco = seg.planos[0].preco;
  }

  getprice(price) {
    return {
      priceId: price.Id,
      idadeDe: price.age_from__c,
      idadeAte: price.age_to__c,
      // minimum: price.product__r.minimum_lives__c,
      // maximum: price.product__r.maximum_lives__c,
      valorDependente: price.dependent_value__c,
      valorTitular: price.holder_value__c
    }
  }

  getplan(carrier, product, price) {
    return {
      seguradoracodigo: carrier.Id,
      seguradora: carrier.Name,
      coparticipacao: product.financial_participation__c,
      acomodacao: product.Product_Classification__c,
      segmentacao: product.segmentation__c,
      nome: product.Name,
      productId: product.Id,
      productFamilyId: product.product_family__r.Id,
      priceId: price.Id,
      preco: 0,
      check: false,
    }
  }

  getInsureImg(nome) {
    return "logoGNDI.jpg";
  }

  getInsurance(carrier, product, price) {
    return {
      seguradoracodigo: carrier.Id,
      nome: carrier.Name.toUpperCase(),
      img: this.getInsureImg(carrier.Name.toUpperCase()),
      menorPreco: 0,
      precos: [this.getprice(price)], // fim preços
      planos: [this.getplan(carrier, product, price)]// fim planos
    }
  }

  async getProdutosPrice() {
    var res = await this.FindPriceAll();
    let seguradoras = [];

    res.data.records.forEach(_price => {
      var _prod = _price.product__r;
      var _family = _prod.product_family__r;
      var _carrier = _family.carrier__r;

      if (seguradoras.some(s => s.seguradoracodigo == _carrier.Id)) {
        var seg = seguradoras.filter(s => s.seguradoracodigo == _carrier.Id)[0];

        // add plano
        var plan = this.getplan(_carrier, _prod, _price);
        if (!seg.planos.some(s => s.productId == plan.productId)) {
          seg.planos.push(plan);
        }

        //add preço
        seg.precos.push(this.getprice(_price));
      }
      else {
        seguradoras.push(this.getInsurance(_carrier, _prod, _price));
      } // fim else
    });

    return seguradoras;
  }

  async getProdutos() {
    var res = await this.FindAll();
    let seguradoras = [];

    for (let index = 0; index < res.data.records.length; index++) {
      var registro = res.data.records[index];
      if (seguradoras.some(s => s.seguradoracodigo == registro.carrier__r.Id)) {
        var seg = seguradoras.filter(s => s.seguradoracodigo == registro.carrier__r.Id)[0];

        // agrupando planos
        seg.planos.push({
          seguradoracodigo: registro.carrier__r.Id,
          coparticipacao: registro.financial_participation__c,
          acomodacao: registro.Product_Classification__c,
          segmentacao: registro.segmentation__c,
          nome: registro.Name,
          preco: 0,
          check: false,
        });

        // sort
        seg.planos = seg.planos.sort(function (a, b) {
          return a.preco <= b.preco ? -1 : a.preco > b.preco ? 1 : 0;
        });

        // set menor preço
        seg.menorPreco = seg.planos[0].preco;
      }
      else {

        seguradoras.push({
          seguradoracodigo: registro.carrier__r.Id,
          nome: registro.carrier__r.Name.toUpperCase(),
          img: "logoGNDI.jpg",
          menorPreco: 0,
          planos: [
            {
              seguradoracodigo: registro.carrier__r.Id,
              seguradora: registro.carrier__r.Name,
              coparticipacao: registro.financial_participation__c,
              acomodacao: registro.Product_Classification__c,
              segmentacao: registro.segmentation__c,
              nome: registro.Name,
              preco: 0,
              check: false,
            }
          ]
        });

      }
    }

    return seguradoras;
  }

  async getRegioes() {
    var res = await this.FindRegions();
    var regiao = res.data.fields.find(e => e.name == "Region__c"); 
    let regioes = [];

    for (let index = 0; index < regiao.picklistValues.length; index++) {
      regioes.push({
          value: regiao.picklistValues[index].value,
          label: regiao.picklistValues[index].label
        });
      }
    
     return regioes; 
    }
}